const classPrefix = 'glossary'
const dataPrefix = 'data-glossary'
const $container = document.querySelector(`[${dataPrefix}]`)


export function glossary() {


}
